export default __webpack_public_path__ + "static/media/blog-img101.003f3f6c.jpg";